import { useMemo } from 'react';

import { emptyArrayOf } from 'ui-components/default-props/empty';
import { useFreightConfiguration } from './use-freight-configuration';

// Rate warnings in the fulfillment-planner context are always parcel-sourced: freight quote
// messaging flows through freightQuoteState → staticWarning instead, so nothing freight-relevant
// is lost by hiding every warning in freight mode.
export const useVisibleRateWarnings = (fulfillmentPlanId: string | undefined, warnings: string[] | null | undefined): string[] => {
  const { isFreightLtl } = useFreightConfiguration(fulfillmentPlanId);

  return useMemo(() => {
    if (isFreightLtl) return emptyArrayOf<string>();
    return warnings ?? emptyArrayOf<string>();
  }, [isFreightLtl, warnings]);
};
